import React from "react";
export default ({ className, onClick, color }) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    className={className ? className : ""}
    onClick={onClick ? onClick : () => {}}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.5 26.8333H3.5C1.51667 26.8333 0 25.3167 0 23.3333V7C0 5.01667 1.51667 3.5 3.5 3.5H24.5C26.4833 3.5 28 5.01667 28 7V23.3333C28 25.3167 26.4833 26.8333 24.5 26.8333ZM3.5 5.83333C2.8 5.83333 2.33333 6.3 2.33333 7V23.3333C2.33333 24.0333 2.8 24.5 3.5 24.5H24.5C25.2 24.5 25.6667 24.0333 25.6667 23.3333V7C25.6667 6.3 25.2 5.83333 24.5 5.83333H3.5Z"
      fill={color}
    />
    <path
      d="M6.99992 8.16669C6.29992 8.16669 5.83325 7.70002 5.83325 7.00002V2.33335C5.83325 1.63335 6.29992 1.16669 6.99992 1.16669C7.69992 1.16669 8.16658 1.63335 8.16658 2.33335V7.00002C8.16658 7.70002 7.69992 8.16669 6.99992 8.16669Z"
      fill={color}
    />
    <path
      d="M20.9999 8.16669C20.2999 8.16669 19.8333 7.70002 19.8333 7.00002V2.33335C19.8333 1.63335 20.2999 1.16669 20.9999 1.16669C21.6999 1.16669 22.1666 1.63335 22.1666 2.33335V7.00002C22.1666 7.70002 21.6999 8.16669 20.9999 8.16669Z"
      fill={color}
    />
    <path
      d="M26.8333 12.8333H1.16667C0.466667 12.8333 0 12.3667 0 11.6667C0 10.9667 0.466667 10.5 1.16667 10.5H26.8333C27.5333 10.5 28 10.9667 28 11.6667C28 12.3667 27.5333 12.8333 26.8333 12.8333Z"
      fill={color}
    />
    <path
      d="M7.82487 15.5084C8.28048 15.964 8.28048 16.7027 7.82487 17.1583C7.36926 17.6139 6.63057 17.6139 6.17496 17.1583C5.71935 16.7027 5.71935 15.964 6.17496 15.5084C6.63057 15.0528 7.36927 15.0528 7.82487 15.5084Z"
      fill={color}
    />
    <path
      d="M7 18.0834C6.06667 18.0834 5.25 17.2667 5.25 16.3334C5.25 15.4 6.06667 14.5834 7 14.5834C7.93333 14.5834 8.75 15.4 8.75 16.3334C8.75 17.2667 7.93333 18.0834 7 18.0834ZM7 15.75C6.65 15.75 6.41667 15.9834 6.41667 16.3334C6.41667 16.6834 6.65 16.9167 7 16.9167C7.35 16.9167 7.58333 16.6834 7.58333 16.3334C7.58333 15.9834 7.35 15.75 7 15.75Z"
      fill={color}
    />
    <path
      d="M7.82487 20.1751C8.28048 20.6307 8.28048 21.3694 7.82487 21.825C7.36926 22.2806 6.63057 22.2806 6.17496 21.825C5.71935 21.3694 5.71935 20.6307 6.17496 20.1751C6.63057 19.7195 7.36927 19.7195 7.82487 20.1751Z"
      fill={color}
    />
    <path
      d="M7 22.75C6.06667 22.75 5.25 21.9333 5.25 21C5.25 20.0667 6.06667 19.25 7 19.25C7.93333 19.25 8.75 20.0667 8.75 21C8.75 21.9333 7.93333 22.75 7 22.75ZM7 20.4167C6.65 20.4167 6.41667 20.65 6.41667 21C6.41667 21.35 6.65 21.5833 7 21.5833C7.35 21.5833 7.58333 21.35 7.58333 21C7.58333 20.65 7.35 20.4167 7 20.4167Z"
      fill={color}
    />
    <path
      d="M12.4916 20.1751C12.9472 20.6307 12.9472 21.3694 12.4916 21.825C12.036 22.2806 11.2973 22.2806 10.8417 21.825C10.3861 21.3694 10.3861 20.6307 10.8417 20.1751C11.2973 19.7195 12.036 19.7195 12.4916 20.1751Z"
      fill={color}
    />
    <path
      d="M11.6667 22.75C10.7334 22.75 9.91675 21.9333 9.91675 21C9.91675 20.0667 10.7334 19.25 11.6667 19.25C12.6001 19.25 13.4167 20.0667 13.4167 21C13.4167 21.9333 12.6001 22.75 11.6667 22.75ZM11.6667 20.4167C11.3167 20.4167 11.0834 20.65 11.0834 21C11.0834 21.35 11.3167 21.5833 11.6667 21.5833C12.0167 21.5833 12.2501 21.35 12.2501 21C12.2501 20.65 12.0167 20.4167 11.6667 20.4167Z"
      fill={color}
    />
    <path
      d="M12.4916 15.5084C12.9472 15.964 12.9472 16.7027 12.4916 17.1583C12.036 17.6139 11.2973 17.6139 10.8417 17.1583C10.3861 16.7027 10.3861 15.964 10.8417 15.5084C11.2973 15.0528 12.036 15.0528 12.4916 15.5084Z"
      fill={color}
    />
    <path
      d="M11.6667 18.0834C10.7334 18.0834 9.91675 17.2667 9.91675 16.3334C9.91675 15.4 10.7334 14.5834 11.6667 14.5834C12.6001 14.5834 13.4167 15.4 13.4167 16.3334C13.4167 17.2667 12.6001 18.0834 11.6667 18.0834ZM11.6667 15.75C11.3167 15.75 11.0834 15.9834 11.0834 16.3334C11.0834 16.6834 11.3167 16.9167 11.6667 16.9167C12.0167 16.9167 12.2501 16.6834 12.2501 16.3334C12.2501 15.9834 12.0167 15.75 11.6667 15.75Z"
      fill={color}
    />
    <path
      d="M17.1584 15.5084C17.614 15.964 17.614 16.7027 17.1584 17.1583C16.7028 17.6139 15.9641 17.6139 15.5085 17.1583C15.0528 16.7027 15.0528 15.964 15.5085 15.5084C15.9641 15.0528 16.7028 15.0528 17.1584 15.5084Z"
      fill={color}
    />
    <path
      d="M16.3333 18.0834C15.3999 18.0834 14.5833 17.2667 14.5833 16.3334C14.5833 15.4 15.3999 14.5834 16.3333 14.5834C17.2666 14.5834 18.0832 15.4 18.0832 16.3334C18.0832 17.2667 17.2666 18.0834 16.3333 18.0834ZM16.3333 15.75C15.9833 15.75 15.7499 15.9834 15.7499 16.3334C15.7499 16.6834 15.9833 16.9167 16.3333 16.9167C16.6832 16.9167 16.9166 16.6834 16.9166 16.3334C16.9166 15.9834 16.6832 15.75 16.3333 15.75Z"
      fill={color}
    />
    <path
      d="M17.1584 20.1751C17.614 20.6307 17.614 21.3694 17.1584 21.825C16.7028 22.2806 15.9641 22.2806 15.5085 21.825C15.0528 21.3694 15.0528 20.6307 15.5085 20.1751C15.9641 19.7195 16.7028 19.7195 17.1584 20.1751Z"
      fill={color}
    />
    <path
      d="M16.3333 22.75C15.3999 22.75 14.5833 21.9333 14.5833 21C14.5833 20.0667 15.3999 19.25 16.3333 19.25C17.2666 19.25 18.0832 20.0667 18.0832 21C18.0832 21.9333 17.2666 22.75 16.3333 22.75ZM16.3333 20.4167C15.9833 20.4167 15.7499 20.65 15.7499 21C15.7499 21.35 15.9833 21.5833 16.3333 21.5833C16.6832 21.5833 16.9166 21.35 16.9166 21C16.9166 20.65 16.6832 20.4167 16.3333 20.4167Z"
      fill={color}
    />
    <path
      d="M21.8249 20.1751C22.2805 20.6307 22.2805 21.3694 21.8249 21.825C21.3693 22.2806 20.6306 22.2806 20.175 21.825C19.7193 21.3694 19.7193 20.6307 20.175 20.1751C20.6306 19.7195 21.3693 19.7195 21.8249 20.1751Z"
      fill={color}
    />
    <path
      d="M21 22.75C20.0667 22.75 19.25 21.9333 19.25 21C19.25 20.0667 20.0667 19.25 21 19.25C21.9333 19.25 22.75 20.0667 22.75 21C22.75 21.9333 21.9333 22.75 21 22.75ZM21 20.4167C20.65 20.4167 20.4167 20.65 20.4167 21C20.4167 21.35 20.65 21.5833 21 21.5833C21.35 21.5833 21.5833 21.35 21.5833 21C21.5833 20.65 21.35 20.4167 21 20.4167Z"
      fill={color}
    />
    <path
      d="M21.8249 15.5084C22.2805 15.964 22.2805 16.7027 21.8249 17.1583C21.3693 17.6139 20.6306 17.6139 20.175 17.1583C19.7193 16.7027 19.7193 15.964 20.175 15.5084C20.6306 15.0528 21.3693 15.0528 21.8249 15.5084Z"
      fill={color}
    />
    <path
      d="M21 18.0834C20.0667 18.0834 19.25 17.2667 19.25 16.3334C19.25 15.4 20.0667 14.5834 21 14.5834C21.9333 14.5834 22.75 15.4 22.75 16.3334C22.75 17.2667 21.9333 18.0834 21 18.0834ZM21 15.75C20.65 15.75 20.4167 15.9834 20.4167 16.3334C20.4167 16.6834 20.65 16.9167 21 16.9167C21.35 16.9167 21.5833 16.6834 21.5833 16.3334C21.5833 15.9834 21.35 15.75 21 15.75Z"
      fill={color}
    />
  </svg>
);
